import React from "react";
import { createRoot } from "react-dom/client";
import "./index.scss";
import { Provider } from "react-redux";
import { datadogRum } from "@datadog/browser-rum";
import { v4 as uuidv4 } from "uuid";
import App from "./App";
import { store } from "../app/store";
import * as serviceWorker from "../serviceWorker";
import config from "../utils/config";

import "@datadog/browser-logs/bundle/datadog-logs";
import { datadogBeforeSend } from "../utils/datadogUtils";

const sessionId = uuidv4();

window.DD_LOGS.init({
    clientToken: "pubfdc4cf8903cb67be1c15935456f4684b",
    site: "us5.datadoghq.com",
    service: "capone-travel-portal",
    version: config.REACT_APP_VERSION,
    env: config.ENV,
    sampleRate: 70,
    trackInteractions: true,
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    beforeSend: (log: any) => {
        // eslint-disable-next-line no-param-reassign
        log.browser_session_id = sessionId;
        // eslint-disable-next-line no-param-reassign
        log.path = window.location.pathname;
    },
});

datadogRum.init({
    applicationId: '0668121e-dabb-46c6-87c0-f09d3ede55e8',
    clientToken: 'pubfdc4cf8903cb67be1c15935456f4684b',
    site: "us5.datadoghq.com",
    service: "capone-travel-portal",
    env: config.ENV,
    sessionSampleRate: 70,
    sessionReplaySampleRate: config.SESSION_REPLAY_SAMPLE_RATE,
    version: config.REACT_APP_VERSION,
    trackUserInteractions: false,
    trackResources: true,
    trackLongTasks: true,
    defaultPrivacyLevel: "mask",
    allowedTracingUrls: [
        "https://travel.capitalone.com",
        "https://travel-qa.capitalone.com",
    ],
    enableExperimentalFeatures: ["feature_flags"],
    beforeSend: datadogBeforeSend,
});

const container = document.getElementById("root");
const root = createRoot(container!);

root.render(
  <Provider store={store}>
    <App />
  </Provider>
);

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister();
